import { useQuery } from '@tanstack/vue-query';

export const useFeaturedArticles = () => {
  // Fetch featured articles for carousel
  const {
    data: featuredArticles,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['featuredArticles'],
    queryFn: async () => {
      const allArticles = await queryCollection('articles')
        .select(
          'title',
          'description',
          'date',
          'authors',
          'badge',
          'image',
          'path',
          'category',
          'featured'
        )
        .order('date', 'DESC')
        .all();

      // Filter for articles with featured flag
      return allArticles.filter((article: any) => article.featured === true).slice(0, 5);
    },
  });

  return {
    featuredArticles,
    error,
    isLoading,
  };
};
